// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.user-selector-input[data-v-2d17d5f6]{\n&[data-v-2d17d5f6] .dropdown-menu{\n        width: 100%;\n}\n}\n.current-user-button[data-v-2d17d5f6] {\n    text-align: start;\n}\n", ""]);
// Exports
module.exports = exports;
